import { useAdminHubQueue } from '@/api/hooks/admin-hub-queue';
import { hasAnyPermissionOrFalse, usePrincipal } from '@/hooks/usePrincipal';
import { hubQueueTabConfig } from '@/pages/admin/configs/hub-queue';

/**
 * Count of hub-pending plugins, for attention badges (sidebar Admin item +
 * Hub Queue tab trigger). Permission-gated at the query level — principals
 * without `admin:view` never fire the request and always read 0. Single
 * React Query cache entry app-wide (same key as the Hub Queue tab's list).
 */
export function useHubQueueCount(): number {
  const principal = usePrincipal();
  const canView = hasAnyPermissionOrFalse(principal, hubQueueTabConfig.permissions);
  const query = useAdminHubQueue({ enabled: canView });
  return canView ? (query.data?.items.length ?? 0) : 0;
}
